package com.xtream.composeapp.presentation.ui.loading

import androidx.compose.animation.core.EaseInOut
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.focusGroup
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.outlined.Help
import androidx.compose.material.icons.filled.ErrorOutline
import androidx.compose.material.icons.filled.Refresh
import androidx.compose.material.icons.outlined.DateRange
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
 import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.LocalSnackbarHostState
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.domain.sealed.ApiSealed
import com.xtream.composeapp.platform.getDeviceInfo
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.composeapp.presentation.widget.ContactInfoDialog
import com.xtream.composeapp.presentation.widget.LottieLoading
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.date_time
import com.xtream.sharedResources.resources.gear_filled
import com.xtream.sharedResources.resources.home
import com.xtream.sharedResources.resources.home_2
import com.xtream.sharedResources.resources.playlist_updated_desc
import com.xtream.sharedResources.resources.retry
import com.xtream.sharedResources.resources.settings
import com.xtream.sharedResources.resources.support_contact
import com.xtream.sharedResources.resources.this_may_take_a_while
import com.xtream.sharedResources.resources.using_cached_data
import com.xtream.composeapp.viewmodel.AppSettingsViewModel
import com.xtream.composeapp.viewmodel.DataLoaderViewModel
import com.xtream.composeapp.viewmodel.UserViewModel
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.AllConst.ACCOUNT_EXPIRED_EXCEPTION
import com.xtream.data_kmp.AllConst.ACCOUNT_UNAVAILABLE_EXCEPTION
import com.xtream.data_kmp.util.exception.UserNotFoundException
import com.xtream.ui.platform.isDpadNavigation
import com.xtream.ui.ui.widget.Button
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import kotlin.time.Clock


@Composable
fun DataLoadingScreen(
    modifier: Modifier = Modifier,
    skipUserRefresh: Boolean = false,
    forceRefreshData: Boolean = false,
    navKey: Screen
){


/*val context= LocalContext.current
     val activity = LocalActivity.current as MainActivity*/

    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current// activity as ViewModelStoreOwner

    val rootNavViewModel: RootNavViewModel = koinViewModel(
        viewModelStoreOwner = viewModelStoreOwner?: error("no viewModelStoreOwner provided")
    )//TODO koinActivityViewModel()

    val appSettingsViewModel: AppSettingsViewModel = koinViewModel(
       /* viewModelStoreOwner = viewModelStoreOwner*/)

    val loadingScreenViewModel: DataLoaderViewModel = koinViewModel()
    val loadingState = loadingScreenViewModel.remoteDataState
    val settingsViewModel = koinViewModel<AppSettingsViewModel>()

    val stateAsErrorOrNull = loadingScreenViewModel.remoteDataState as? ApiSealed.Error
    val hasError = stateAsErrorOrNull != null
    val errorMessage = stateAsErrorOrNull?.message
    val exception = stateAsErrorOrNull?.exception
    val userViewModel: UserViewModel = koinViewModel()

    val snackbarHostState = LocalSnackbarHostState.current

    val scope = rememberCoroutineScope()
    val deviceInfo = getDeviceInfo()
    val  cachedDataMsg=stringResource(Res.string.using_cached_data)
    fun loadConfigAndData(shouldSkipUserRefresh: Boolean = skipUserRefresh, shouldForceRefreshData: Boolean = forceRefreshData){
        scope.launch {
           // loadingScreenViewModel.setLastUpdatedDataMillis(
            //   Clock.System.now().toEpochMilliseconds()
           // )

          //  println("Test, "+ loadingScreenViewModel.cachedUserServer())
            loadingScreenViewModel.fetchAppConfigAndData(true, deviceInfo = deviceInfo,skipUserRefresh = shouldSkipUserRefresh, )
        }
    }
    fun goToNextRoute(){
       scope.launch {


            rootNavViewModel.backStack.addAll(settingsViewModel.defaultRoute(userViewModel.loggedInUser()))
            rootNavViewModel.backStack.remove(navKey)

        }
    }
    fun showSnackbar(message: String) {
        scope.launch {
            snackbarHostState.showSnackbar(message,

                )
        }
    }
    Column  (
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = modifier.fillMaxSize()
    ) {
       // InTvAnimatedLogo(animate = loadingState is ApiSealed.Loading)
        if(loadingState is ApiSealed.Loading)
            LottieLoading()
       if(hasError) {
          AnimatedError()
        }
        MessageText(
            errorMessage
                ?: if (loadingState is ApiSealed.Loading) stringResource(Res.string.this_may_take_a_while).uppercase() else ""
        )



        ErrorActionLayout(
            show = hasError,

             showSkipButton =

                exception is UserNotFoundException ||
                errorMessage?.uppercase() in listOf(
                    AllConst.JSON_CONVERT_EXCEPTION, ACCOUNT_EXPIRED_EXCEPTION, ACCOUNT_UNAVAILABLE_EXCEPTION,
                AllConst.USER_NOT_FOUND_EXCEPTION).map { it.uppercase() },
            showDateSettingsButton = errorMessage.equals(
                AllConst.SYSTEM_TIME_INVALID,
                ignoreCase = true
            ),
            onRetry = {
                //if (serverConfigState is ApiSealed.Error)
                loadConfigAndData(shouldSkipUserRefresh = false, shouldForceRefreshData = false)
                //else
                //  userViewModel.loadUser(user?.userInfo?.username, user?.userInfo?.password)
            },
            onSkip = {
                with(rootNavViewModel){
                    navigate( Screen.NavBar)
                    pop(navKey)
                }
                scope.launch(Dispatchers.Main) {

                    showSnackbar(
                        message = cachedDataMsg
                            ?: "",

                        )
                    //userViewModel.logOut()
                    //activity.restartActivity(true)

                }
            }

        )
    }

    //load Data
    LaunchedEffect(Unit) {
        loadConfigAndData()
    }


    val playlistUpdatedMSG = stringResource(Res.string.playlist_updated_desc)
    LaunchedEffect(loadingState) {
        when(loadingState){
            is ApiSealed.Error -> {
                showSnackbar( loadingState.message)
            }
            is ApiSealed.Success -> {
                showSnackbar( playlistUpdatedMSG)
                scope.launch(Dispatchers.Default) {
                    appSettingsViewModel.setLastUpdatedDataMillis(Clock.System.now().toEpochMilliseconds())
                }
                goToNextRoute()

            }
            is ApiSealed.Finished  -> {
                goToNextRoute()
            }
            else -> {

            }
        }
    }
    /*
    - should check for saved user ✅
    - should check is need data refresh? ✅
    - then:
       **when need data refresh**
        . load server config
        . if there is server URL for activation and account its OK can load user, else show cause of error
        . load user either saved or from server config
       **when don't need data refresh**
        . check is there saved stack? if yes then go to it else go to navbar

     */






}







@Composable
fun ErrorActionLayout(
    show: Boolean = true,
    showSettingsButton: Boolean = true,
    showSkipButton: Boolean = false,
    showDateSettingsButton: Boolean = false,

     onRetry:()->Unit = {},
    onSkip:()->Unit = {}




){
         val focusRequester = remember { FocusRequester() }
    var showSupportDialog by remember { mutableStateOf(false) }
      ContactInfoDialog( show = showSupportDialog, onDismiss = {
        showSupportDialog = false
    })

    if(show) {
        FlowRow (

            modifier = Modifier
                .padding(vertical = 24.dp)
                .focusGroup(),

            horizontalArrangement = Arrangement.Absolute.Center,
            verticalArrangement = Arrangement.spacedBy(16.dp)

        ) {
            Button(
                title = stringResource(Res.string.support_contact),
                leadingIcon = rememberVectorPainter(Icons.AutoMirrored.Outlined.Help)
            ) {
                showSupportDialog = true

            }
            Spacer(modifier = Modifier.width(24.dp))

            if (showSettingsButton && !showDateSettingsButton) {
                Button(
                    title = stringResource(Res.string.settings),
                    leadingIcon = painterResource( Res.drawable.gear_filled)
                ) {
                    //TODO activity?.launchSystemWiFiScreen()

                }
                Spacer(modifier = Modifier.width(24.dp))
            }
            if (showDateSettingsButton) {
                Button(
                    title = stringResource(Res.string.date_time),
                    leadingIcon = rememberVectorPainter(Icons.Outlined.DateRange)
                ) {
                   //TODO activity?.openDateTimeSettings()

                }
                Spacer(modifier = Modifier.width(24.dp))
            }
            Button(
                modifier = Modifier.focusRequester(focusRequester),
                title = stringResource(Res.string.retry),
                leadingIcon = rememberVectorPainter(Icons.Default.Refresh)
            ) {
                onRetry()

            }
            if (showSkipButton) {
                Spacer(modifier = Modifier.width(24.dp))
                Button(
                    title = stringResource(Res.string.home),
                    leadingIcon = painterResource( Res.drawable.home_2)
                ) {
                    onSkip()

                }
            }

        }

        LaunchedEffect(Unit) {
            focusRequester.requestFocus()
        }
    }
}






@Composable
fun MessageText(text: String){
    val isDpad= isDpadNavigation()
    Text(
        color = MaterialTheme.colorScheme.onBackground,
        modifier = Modifier.padding(12.dp),
        style = MaterialTheme.typography.let {
            if(isDpad) it.titleLarge else it.titleMedium
        }        ,
        textAlign = TextAlign.Center,
        text =text,
    )
}

@Composable
private fun AnimatedError() {
    val infiniteTransition = rememberInfiniteTransition(label = "error")



    val alpha by infiniteTransition.animateFloat(
        initialValue = 1f,
        targetValue = 0.3f,
        animationSpec = infiniteRepeatable(
            animation = tween(2000, easing = EaseInOut),
            repeatMode = RepeatMode.Reverse
        ),
        label = "alpha"
    )

    Icon(
        imageVector = Icons.Default.ErrorOutline,
        modifier = Modifier
            .size(80.dp)
            .graphicsLayer {

                this.alpha = alpha
            },
        contentDescription = null
    )
}

